import { Http } from '@/http/http';
import {
  REG_REQUEST, REG_SUCCESS, REG_ERROR,
  SEND_CODE_REQUEST, SEND_CODE_ERROR, SEND_CODE_SUCCESS,
  AUTH_SUCCESS, AUTH_REQUEST, AUTH_ERROR,
  AUTH_LOGOUT,
} from './types';
import { LOAD_INITIAL_DATA_REQUEST, RESET_INITIAL_STATUS } from '../app/types';
import { RESET_EVENT_DATA } from '../events/types';
import { RESET_USER_DATA } from '../user/types';
import { RESET_CURRENCY_DATA } from '../currency/types';
import { RESET_OPERATIONS_DATA } from '../operations/types';
import router from '../../router/router';

const sendCode = async ({ commit }, data) => {
  commit(SEND_CODE_REQUEST);
  try {
    const {
      purpose, ...user
    } = data;
    const baseQuery = '/v2/auth/code/';
    const queryParams = purpose ? `?for=${purpose}` : '';
    const query = `${baseQuery}${queryParams}`;
    await Http.post(query, user);
    commit(SEND_CODE_SUCCESS);
  } catch (e) {
    commit(SEND_CODE_ERROR, e.message || 'error');
    throw new Error(e.message);
  }
};

const registerUser = async ({ commit, dispatch }, data) => {
  commit(REG_REQUEST);
  try {
    const {
      purpose, ...user
    } = data;
    const baseQuery = '/v2/auth/password/';
    const queryParams = purpose ? `?for=${purpose}` : '';
    const query = `${baseQuery}${queryParams}`;
    const res = await Http.post(query, user);
    if (res.error) {
      throw new Error(res.error);
    }
    commit(REG_SUCCESS);
    await dispatch(AUTH_REQUEST, {
      phone: user.phone,
      password: user.password,
      remember: true,
    });
    return res;
  } catch (e) {
    commit(REG_ERROR, e);
    throw e;
  }
};

const loginUser = ({ commit, dispatch }, user) => new Promise(
  (resolve, reject) => {
    commit(AUTH_REQUEST);
    Http.post('/v2/auth/login/', user)
      .then((resp) => {
        const { token = 'no-token' } = resp;
        if (user.remember && token) {
          localStorage.setItem('user-token', `Token ${token}`);
        } else if (token) {
          sessionStorage.setItem('user-token', `Token ${token}`);
        }
        if (resp.error) {
          commit(AUTH_ERROR, resp.error);
          commit(AUTH_LOGOUT);
          reject(resp.error);
        }
        Http.HEADERS.Authorization = `Token ${token}`;
        commit(AUTH_SUCCESS, { token });
        dispatch(LOAD_INITIAL_DATA_REQUEST)
          .then(() => {
            resolve(resp);
          });
      })
      .catch((err) => {
        commit(AUTH_ERROR, err);
        reject(err);
      });
  },
);

const logoutUser = ({ commit }) => new Promise((resolve) => {
  Http.post('/account/logout/')
    .then(() => {
      delete Http.HEADERS.Authorization;
      localStorage.removeItem('user-token');
      commit(AUTH_LOGOUT);
      commit(RESET_EVENT_DATA);
      commit(RESET_USER_DATA);
      commit(RESET_CURRENCY_DATA);
      commit(RESET_OPERATIONS_DATA);
      commit(RESET_INITIAL_STATUS);
      router.push({ name: 'SignInPage' }).catch(() => {});
      resolve();
    });
});
// const logoutUser = () => {};
export const actions = {
  [SEND_CODE_REQUEST]: sendCode,
  [REG_REQUEST]: registerUser,
  [AUTH_REQUEST]: loginUser,
  [AUTH_LOGOUT]: logoutUser,
};
